import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import LoginModal from '../LoginModal';
import ConsultingSection from '../ConsultingSection';
import CaseStudiesSection from '../cases/CaseStudiesSection';
import SEO from '../SEO';
import { Badge } from '../ui/badge';

const ConsultoriaPage = () => {
  const navigate = useNavigate();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <>
      <SEO 
        title="AJ|BIM Consultoria - Implementação BIM Empresarial"
        description="Diagnóstico, implementação e capacitação BIM para empresas. Metodologia comprovada com cases de sucesso em grandes organizações."
        keywords="consultoria BIM, implementação BIM, diagnóstico BIM, capacitação empresarial"
      />
      <Header onLoginClick={() => setIsLoginModalOpen(true)} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-900/30 via-black to-black">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="bg-blue-600/20 text-blue-400 border-blue-500/30 mb-4">
              AJ|BIM Consultoria
            </Badge>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Consultoria e <span className="text-blue-500">Implementação BIM</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Diagnóstico de maturidade, implementação completa e capacitação 
              para sua empresa alcançar excelência em BIM.
            </p>
          </div>
        </div>
      </section>

      {/* Consulting Services */}
      <ConsultingSection />

      {/* Cases de Sucesso */}
      <CaseStudiesSection />

      {/* Voltar */}
      <section className="py-12 bg-black">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="border-zinc-700 text-white hover:bg-zinc-800"
          >
            <ArrowLeft className="mr-2" size={18} />
            Voltar ao Portal
          </Button>
        </div>
      </section>

      <Footer />
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </>
  );
};

export default ConsultoriaPage;
